/* TEN452 studio: live recolouring of baked render layers.
   light  R = matte shade/1.5, G = metal light/2.2, B = metal white spec/0.27
   data   R = Qada2 index (255 = not map), G = matte spec/0.045, B = map coverage */
(function () {
  var st = document.querySelector('[data-studio]');
  if (!st) return;
  var BASE = {
    stone: [0.86, 0.855, 0.835], sand: [0.78, 0.68, 0.53], ash: [0.60, 0.60, 0.58],
    charcoal: [0.20, 0.20, 0.205], cedar: [0.20, 0.29, 0.21], terracotta: [0.66, 0.36, 0.25]
  };
  var METAL = {
    copper: [0.80, 0.47, 0.30], bronze: [0.66, 0.50, 0.30], gold: [0.85, 0.68, 0.36], silver: [0.78, 0.78, 0.80]
  };
  var names = st.getAttribute('data-names').split('|');
  var cv = st.querySelector('canvas'), ctx = cv.getContext('2d');
  var ph = st.querySelector('.studio__ph');
  var live = st.querySelector('[data-live]');
  var cfg = document.querySelector('[data-cfg]');
  var sel = document.getElementById('caza');
  var views = {}, cur = 'top', state = { base: 'stone', metal: 'none', caza: -1 }, flash = null;

  function img(src) {
    return new Promise(function (res, rej) { var i = new Image(); i.decoding = 'async'; i.onload = function () { res(i); }; i.onerror = rej; i.src = src; });
  }
  /* lossless layers ship as base64 WebP inside JSON so the CDN never re-encodes them */
  function packed(src) {
    return fetch(src).then(function (r) { return r.json(); }).then(function (b64) {
      var bin = atob(b64), u = new Uint8Array(bin.length);
      for (var k = 0; k < bin.length; k++) u[k] = bin.charCodeAt(k);
      var url = URL.createObjectURL(new Blob([u], { type: 'image/webp' }));
      return img(url).then(function (i) { URL.revokeObjectURL(url); return i; });
    });
  }
  function pix(i) {
    var c = document.createElement('canvas'); c.width = i.naturalWidth; c.height = i.naturalHeight;
    var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(i, 0, 0);
    return x.getImageData(0, 0, c.width, c.height).data;
  }
  function load(v) {
    if (views[v]) return views[v].p;
    var m = JSON.parse(st.getAttribute('data-' + v)), o = { m: m };
    o.p = Promise.all([img(m.bg), packed(m.light), packed(m.data)]).then(function (r) {
      o.bg = pix(r[0]); o.L = pix(r[1]); o.D = pix(r[2]);
      o.out = ctx.createImageData(m.w, m.h); o.out.data.set(o.bg);
      return o;
    });
    views[v] = o;
    return o.p;
  }

  function render() {
    var o = views[cur]; if (!o || !o.L) return;
    var m = o.m, L = o.L, D = o.D, B = o.bg, out = o.out.data;
    var b = BASE[state.base], mt = state.metal !== 'none' && state.caza >= 0 ? METAL[state.metal] : null, cz = state.caza;
    var br = b[0] * 255, bgc = b[1] * 255, bb = b[2] * 255;
    for (var yy = 0; yy < m.ch; yy++) {
      var i = yy * m.cw * 4, j = ((m.y + yy) * m.w + m.x) * 4;
      for (var xx = 0; xx < m.cw; xx++, i += 4, j += 4) {
        var a = D[i + 2];
        if (a === 0) { out[j] = B[j]; out[j + 1] = B[j + 1]; out[j + 2] = B[j + 2]; continue; }
        var r, g, bl;
        if (mt && D[i] === cz) {
          var ml = L[i + 1] * (2.2 / 255), cs = L[i + 2] * (0.27 * 255 / 255);
          r = mt[0] * 255 * ml + cs; g = mt[1] * 255 * ml + cs; bl = mt[2] * 255 * ml + cs;
        } else {
          var s = L[i] * (1.5 / 255), sp = D[i + 1] * (0.045 * 255 / 255);
          r = br * s + sp; g = bgc * s + sp; bl = bb * s + sp;
        }
        if (a === 255) { out[j] = r; out[j + 1] = g; out[j + 2] = bl; }
        else { var f = a / 255, e = 1 - f; out[j] = B[j] * e + r * f; out[j + 1] = B[j + 1] * e + g * f; out[j + 2] = B[j + 2] * e + bl * f; }
      }
    }
    if (cv.width !== m.w || cv.height !== m.h) { cv.width = m.w; cv.height = m.h; }
    ctx.putImageData(o.out, 0, 0);
    st.classList.add('is-live');
  }

  /* brief gold outline around the chosen Qada2, so you can find it without a metal finish */
  function outline() {
    var o = views[cur]; if (!o || !o.L || state.caza < 0) return;
    var m = o.m, D = o.D, cz = state.caza, idx = [], w = m.cw, h = m.ch;
    for (var y = 2; y < h - 2; y++) for (var x = 2; x < w - 2; x++) {
      var i = (y * w + x) * 4;
      if (D[i] !== cz || D[i + 2] < 128) continue;
      if (D[i + 8] !== cz || D[i - 8] !== cz || D[i + w * 8] !== cz || D[i - w * 8] !== cz) idx.push(((m.y + y) * m.w + m.x + x) * 4);
    }
    if (!idx.length) return;
    var snap = new Uint8ClampedArray(idx.length * 3), out = o.out.data;
    for (var k = 0; k < idx.length; k++) { snap[k * 3] = out[idx[k]]; snap[k * 3 + 1] = out[idx[k] + 1]; snap[k * 3 + 2] = out[idx[k] + 2]; }
    var t0 = performance.now(), id = {};
    flash = id;
    (function step(t) {
      if (flash !== id) return;
      var p = Math.min((t - t0) / 1600, 1), al = p < 0.25 ? p / 0.25 : 1 - (p - 0.25) / 0.75;
      for (var k = 0; k < idx.length; k++) {
        var q = idx[k];
        out[q] = snap[k * 3] + (232 - snap[k * 3]) * al; out[q + 1] = snap[k * 3 + 1] + (196 - snap[k * 3 + 1]) * al; out[q + 2] = snap[k * 3 + 2] + (120 - snap[k * 3 + 2]) * al;
      }
      ctx.putImageData(o.out, 0, 0);
      if (p < 1) requestAnimationFrame(step);
    })(t0);
  }

  function label() {
    var cap = function (s) { return s.charAt(0).toUpperCase() + s.slice(1); };
    var t = 'Live render · ' + cap(state.base) + ' map';
    if (state.caza >= 0) t += state.metal !== 'none' ? ' · ' + names[state.caza] + ' in ' + state.metal : ' · ' + names[state.caza];
    else if (state.metal !== 'none') t += ' · choose your Qada2 to see it in ' + state.metal;
    live.textContent = t;
    var vb = cfg.querySelector('[data-val="base"]'), vm = cfg.querySelector('[data-val="metal"]');
    if (vb) vb.textContent = cap(state.base);
    if (vm) vm.textContent = state.metal === 'none' ? 'None' : cap(state.metal);
  }

  function update(doFlash) {
    label(); flash = null;
    load(cur).then(function () { render(); if (doFlash) outline(); });
  }

  cfg.addEventListener('change', function (e) {
    var t = e.target;
    if (t.dataset.base) state.base = t.dataset.base;
    else if (t.dataset.metal) state.metal = t.dataset.metal;
    else if (t === sel) { state.caza = names.indexOf(sel.value); update(state.metal === 'none'); return; }
    update(false);
  });

  st.querySelectorAll('[data-view]').forEach(function (b) {
    b.addEventListener('click', function () {
      cur = b.dataset.view;
      var m = JSON.parse(st.getAttribute('data-' + cur));
      ph.width = m.w; ph.height = m.h; ph.src = m.bg;
      st.querySelectorAll('[data-view]').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
      update(false);
    });
  });

  /* tap the map to choose a Qada2 */
  function hit(e) {
    var o = views[cur]; if (!o || !o.L) return -1;
    var r = cv.getBoundingClientRect(), m = o.m;
    var x = Math.floor((e.clientX - r.left) / r.width * m.w) - m.x, y = Math.floor((e.clientY - r.top) / r.height * m.h) - m.y;
    if (x < 0 || y < 0 || x >= m.cw || y >= m.ch) return -1;
    var i = (y * m.cw + x) * 4;
    return o.D[i + 2] > 100 && o.D[i] < 26 ? o.D[i] : -1;
  }
  cv.addEventListener('click', function (e) {
    var k = hit(e); if (k < 0) return;
    sel.value = names[k]; sel.dispatchEvent(new Event('change', { bubbles: true }));
  });
  cv.addEventListener('mousemove', function (e) {
    var k = hit(e); cv.style.cursor = k >= 0 ? 'pointer' : '';
    cv.title = k >= 0 ? names[k] : '';
  });

  /* controls sit under the render on phones, in the buy box on desktop */
  var mq = window.matchMedia('(max-width: 900px)'), home = cfg.parentNode, homeNext = cfg.nextSibling, slot = st.querySelector('[data-slot-m]');
  function place() { if (mq.matches) slot.appendChild(cfg); else home.insertBefore(cfg, homeNext); }
  place();
  if (mq.addEventListener) mq.addEventListener('change', place); else mq.addListener(place);

  /* restore choices kept by the browser on back/forward */
  var cb = cfg.querySelector('[data-base]:checked'), cm = cfg.querySelector('[data-metal]:checked');
  if (cb) state.base = cb.dataset.base;
  if (cm) state.metal = cm.dataset.metal;
  if (sel.value) state.caza = names.indexOf(sel.value);
  update(false);
  var idle = window.requestIdleCallback || function (f) { setTimeout(f, 1500); };
  idle(function () { load('angle'); });
})();
